import { DateTime } from 'luxon';
import { Job, JobConfig, JobStatus, JobType, TaskConfig, TaskType } from './job-tasks';

export namespace JobTaskParsers {
  export type TaskConfigJson = {
    id: string;
    type: string;
    header: string;
    instructions?: string;
    metadata?: any;
    required: boolean;
    updatedAt: string;
    updatedBy: number;
    version: number;
  };
  export type JobConfigJson = {
    id: string;
    jobType: JobType;
    name: string;
    taskConfigs: TaskConfigJson[];

    products?: number[];
    categories?: number[];
  };

  export function parseTaskConfig(taskConfigJson: TaskConfigJson): TaskConfig {
    return {
      id: taskConfigJson.id,
      type: taskConfigJson.type as TaskType,
      header: taskConfigJson.header,
      instructions: taskConfigJson.instructions,
      metadata: taskConfigJson.metadata,
      required: taskConfigJson.required,
      updatedAt: DateTime.fromISO(taskConfigJson.updatedAt),
      updatedBy: taskConfigJson.updatedBy,
      version: taskConfigJson.version,
    };
  }

  export function parseJobConfig(input: JobConfigJson): JobConfig {
    return {
      id: input.id,
      jobType: input.jobType,
      name: input.name,
      taskConfigs: input.taskConfigs.map(parseTaskConfig),
      products: input.products,
      categories: input.categories,
    };
  }

  export type TaskJson = {
    id: string;
    jobId: string;
    type: TaskType;
    taskConfigId: string;
    taskConfigVersion: number;
    header: string;
    instructions?: string;
    status: JobStatus;
    metadata?: Record<string, any>;
    startedAt?: DateTime;
    completedAt?: DateTime;
    //  completedBy?: AdminParsers.AdminJson;
  };
  export type JobJson = {
    id: string;
    entityType: string;
    entityId: string;
    type: JobType;
    status: string;
    createdAt: string;
    updatedAt: string;
    tasks: TaskJson[];
  };

  export function parseJob(input: JobJson): Job {
    return {
      id: input.id,
      entityType: 'Order',
      entityId: input.entityId,
      type: input.type,
      status: input.status as JobStatus,
      createdAt: DateTime.fromISO(input.createdAt),
      updatedAt: DateTime.fromISO(input.updatedAt),
      updatedBy: 0, // meh do i really need this
      tasks: input.tasks.map((task) => ({
        id: task.id,
        jobId: task.jobId,
        type: task.type,
        taskConfigId: task.taskConfigId,
        taskConfigVersion: task.taskConfigVersion,
        header: task.header,
        instructions: task.instructions,
        status: task.status,
        metadata: task.metadata,
        startedAt: task.startedAt,
        completedAt: task.completedAt,
        // completedBy: task.completedBy ? AdminParsers.parseAdmin(task.completedBy) : undefined,
      })),
    };
  }
}
